import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Logo, LogoMark } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, apiError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bentornato, ${u.username}!`);
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 tw-grain">
      <div className="mx-auto flex w-full max-w-md flex-1 flex-col justify-center px-5 py-10">
        <div className="mb-8 flex flex-col items-center text-center">
          <LogoMark className="mb-2 h-40 w-40 object-contain" />
          <p className="max-w-xs text-sm font-medium text-zinc-500">
            La community dei pronostici di calcio. Rispondi, guadagna punti, vinci i premi di Tony.
          </p>
        </div>

        <form onSubmit={submit} className="space-y-4 rounded-3xl border-2 border-zinc-950 bg-white p-6 shadow-[6px_6px_0_0_#09090b]">
          <h1 className="font-display text-3xl font-black uppercase text-zinc-950">Accedi</h1>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input data-testid="login-email-input" id="email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="tu@email.com" className="rounded-xl" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input data-testid="login-password-input" id="password" type="password" required value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="rounded-xl" />
          </div>
          <Button data-testid="login-submit-button" type="submit" disabled={loading}
            className="w-full rounded-full bg-green-500 py-6 text-base font-black uppercase text-zinc-950 hover:bg-green-600">
            {loading ? "Accesso..." : "Entra"}
          </Button>
          <div className="flex items-center justify-between text-sm">
            <Link data-testid="forgot-password-link" to="/forgot-password" className="font-semibold text-zinc-500 hover:text-zinc-950">
              Password dimenticata?
            </Link>
            <Link data-testid="go-register-link" to="/register" className="font-bold text-green-600 hover:underline">
              Registrati
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
